module.exports = __webpack_public_path__ + "static/img/200204.de66c8c4.png";